import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_close.svg'


const _hoisted_1 = { class: "flex flex-grow flex-col gap-2" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex flex-grow gap-1 text-gray-lp-300" }
const _hoisted_4 = {
  key: 0,
  class: "text-gray-lp-600 font-normal"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "text-xl" }, "+", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-3 h-3",
  alt: "remove"
}, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "text-gray-lp-600 py-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalSendInvoicePicker = _resolveComponent("ModalSendInvoicePicker")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
        (_ctx.isOptional)
          ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('tagihan.form.optional')), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args))),
        class: "flex items-center gap-1 text-red-lp-100 font-semibold"
      }, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('tagihan.create.add')), 1)
      ])
    ]),
    _createVNode("div", {
      class: "flex flex-wrap items-start gap-2 border border-gray-lp-400 rounded-md px-4 py-3 overflow-y-auto",
      style: { height: _ctx.pickerHeight }
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modelValue, (tag, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: "flex items-center gap-1 px-1 py-1 bg-gray-lp-200 rounded-sm text-sm text-gray-lp-300"
        }, [
          _createTextVNode(_toDisplayString(tag.contact) + " ", 1),
          _createVNode("button", {
            onClick: ($event: any) => (_ctx.removeTag(index)),
            class: "text-gray-400 hover:text-red-500"
          }, [
            _hoisted_6
          ], 8, ["onClick"])
        ]))
      }), 128)),
      (!_ctx.modelValue.length)
        ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('tagihan.create.notYetAdded')), 1))
        : _createCommentVNode("", true)
    ], 4),
    _createVNode(_component_ModalSendInvoicePicker, {
      show: _ctx.showModal,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal = $event)),
      mode: "emit",
      onSubmit: _ctx.handleModalSubmit,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModal = false))
    }, null, 8, ["show", "onSubmit"])
  ]))
}